import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Catalog } from 'app/Model/Catalog/Catalog';
import { Agreement } from 'app/Model/Catalog/Agreement';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { SystemService } from 'app/Services/system.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'np-container-catalog-edit',
  templateUrl: './container-catalog-edit.component.html',
  styleUrls: ['./container-catalog-edit.component.css']
})
export class ContainerCatalogEditComponent implements OnChanges {

  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() catalog: Catalog | null = null;
  @Input() popupTitle?: string;

  @Output() saved = new EventEmitter<Catalog>();
  @Output() canceled = new EventEmitter<void>();

  fullScreen = false;
  statusCsv = '';
  territoriesCsv = '';

  isSaving = false;
  error: string | null = null;

  constructor(
    private readonly catalogService: CatalogService,
    private readonly systemService: SystemService,
    private readonly translate: TranslateService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    const catalogChanged = !!changes['catalog'];
    const becameVisible =
      !!changes['visible'] &&
      changes['visible'].currentValue === true &&
      changes['visible'].previousValue !== true;

    if ((catalogChanged || becameVisible) && this.catalog && this.visible) {
      this.statusCsv = (this.catalog.catalogState ?? []).join(', ');
      this.territoriesCsv = (this.catalog.territories ?? []).join(', ');

      if (!this.catalog.agreement) {
        this.catalog.agreement = new Agreement();
      }

      this.error = null;
    }
  }

  getTitle(): string {
    return this.popupTitle || this.translate.instant('Katalog');
  }

  onCancel(): void {
    this.canceled.emit();
    this.visible = false;
    this.visibleChange.emit(false);
  }

  async onSave(): Promise<void> {
    if (!this.catalog) {
      this.onCancel();
      return;
    }

    this.isSaving = true;
    this.error = null;

    this.catalog.catalogState = this.csvToArray(this.statusCsv);
    this.catalog.territories = this.csvToArray(this.territoriesCsv);

    if (!this.catalog.agreement) {
      this.catalog.agreement = new Agreement();
    }

    try {
      this.catalogService.catalog = this.catalog;

      const result = await this.catalogService.updateCatalog();

      if (result === false) {
        this.error = this.translate.instant('Fehler beim Speichern des Kataloges.');
        this.isSaving = false;
        return;
      }

      this.systemService.notifyInfo(
        this.translate.instant('Katalog-Metadaten wurden geändert')
      );

      this.saved.emit(this.catalog);
      this.visible = false;
      this.visibleChange.emit(false);

    } catch (err: any) {
      this.error =
        err?.message ?? this.translate.instant('Fehler beim Speichern des Kataloges.');
    } finally {
      this.isSaving = false;
    }
  }

  toggleFullScreen(): void {
    this.fullScreen = !this.fullScreen;
  };

  csvToArray(csv: string): string[] {
    if (!csv) {
      return null;
    }

    const items = csv
      .split(',')
      .map(x => x.trim())
      .filter(x => !!x);

    return items.length ? items : null;
  }
}
